(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    (function () {

  /*
   * Prevent duplicate initialization.
   *
   * Shopify can render sections multiple times.
   */

  if (
    window.__productMediaZoomInitialized
  ) {

    return;

  }

  window.__productMediaZoomInitialized = true;


  /*
   * ============================================================
   * STATE
   * ============================================================
   */

  let activeStage = null;

  let activeImage = null;

  let scale = 1;

  let translateX = 0;

  let translateY = 0;

  let startX = 0;

  let startY = 0;

  let dragging = false;


  /*
   * Mobile pinch
   */

  let pinchStartDistance = null;

  let pinchStartScale = 1;


  /*
   * ============================================================
   * UPDATE TRANSFORM
   * ============================================================
   *
   * This transforms the WHOLE stage.
   *
   * Background
   * +
   * Product Image
   *
   * zoom together.
   */

  function updateTransform() {

    if (!activeStage) {

      return;

    }


    activeStage.style.transform =
      'translate3d(' +
      translateX +
      'px, ' +
      translateY +
      'px, 0) scale(' +
      scale +
      ')';

  }


  /*
   * ============================================================
   * SET ZOOM CLASSES
   * ============================================================
   *
   * Adds .is-zoomed to BOTH:
   *
   * .product-media__zoom-stage
   *
   * .product-media__image
   *
   */

  function setZoomedState() {

    if (!activeStage) {

      return;

    }


    activeStage.classList.add(
      'is-zoomed'
    );


    activeImage =
      activeStage.querySelector(
        '.product-media__image'
      );


    if (activeImage) {

      activeImage.classList.add(
        'is-zoomed'
      );

    }

  }


  /*
   * ============================================================
   * REMOVE ZOOM CLASSES
   * ============================================================
   */

  function removeZoomedState() {

    if (!activeStage) {

      return;

    }


    activeStage.classList.remove(
      'is-zoomed'
    );


    activeStage.classList.remove(
      'is-dragging'
    );


    if (activeImage) {

      activeImage.classList.remove(
        'is-zoomed'
      );

    }


    activeImage =
      activeStage.querySelector(
        '.product-media__image'
      );


    if (activeImage) {

      activeImage.classList.remove(
        'is-zoomed'
      );

    }

  }


  /*
   * ============================================================
   * RESET
   * ============================================================
   */

  function resetZoom() {

    scale = 1;

    translateX = 0;

    translateY = 0;

    dragging = false;


    if (!activeStage) {

      return;

    }


    removeZoomedState();


    activeStage.style.transform =
      'translate3d(0, 0, 0) scale(1)';

  }


  /*
   * ============================================================
   * OPEN / ZOOM
   * ============================================================
   */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '[data-product-zoom-open]'
        );


      if (!button) {

        return;

      }


      event.preventDefault();

      event.stopPropagation();


      activeStage =
        button.closest(
          '[data-product-zoom-stage]'
        );


      if (!activeStage) {

        return;

      }


      activeImage =
        activeStage.querySelector(
          '.product-media__image'
        );


      /*
       * First click:
       *
       * 1x → 2x
       */

      if (scale <= 1) {

        scale = 2;

        translateX = 0;

        translateY = 0;


        setZoomedState();


        updateTransform();

      }

    },
    true
  );


  /*
   * ============================================================
   * DOUBLE CLICK
   * ============================================================
   *
   * Reset.
   */

  document.addEventListener(
    'dblclick',
    function (event) {

      const stage =
        event.target.closest(
          '[data-product-zoom-stage]'
        );


      if (!stage) {

        return;

      }


      activeStage = stage;


      activeImage =
        activeStage.querySelector(
          '.product-media__image'
        );


      if (scale > 1) {

        resetZoom();

      }

    },
    true
  );


  /*
   * ============================================================
   * MOUSE WHEEL ZOOM
   * ============================================================
   */

  document.addEventListener(
    'wheel',
    function (event) {

      const stage =
        event.target.closest(
          '[data-product-zoom-stage]'
        );


      if (!stage) {

        return;

      }


      /*
       * Only zoom with wheel if already
       * in zoom mode.
       */

      if (scale <= 1) {

        return;

      }


      event.preventDefault();


      activeStage = stage;


      activeImage =
        activeStage.querySelector(
          '.product-media__image'
        );


      const amount =
        event.deltaY < 0
          ? 0.2
          : -0.2;


      scale += amount;


      /*
       * Limit zoom.
       */

      scale = Math.max(
        1,
        Math.min(4, scale)
      );


      if (scale <= 1) {

        resetZoom();

        return;

      }


      setZoomedState();


      updateTransform();

    },
    {
      passive: false
    }
  );


  /*
   * ============================================================
   * MOUSE DOWN
   * ============================================================
   */

  document.addEventListener(
    'mousedown',
    function (event) {

      const stage =
        event.target.closest(
          '[data-product-zoom-stage]'
        );


      if (!stage) {

        return;

      }


      if (scale <= 1) {

        return;

      }


      activeStage = stage;


      activeImage =
        activeStage.querySelector(
          '.product-media__image'
        );


      dragging = true;


      startX =
        event.clientX -
        translateX;


      startY =
        event.clientY -
        translateY;


      activeStage.classList.add(
        'is-dragging'
      );


      if (activeImage) {

        activeImage.classList.add(
          'is-zoomed'
        );

      }


      event.preventDefault();

    }
  );


  /*
   * ============================================================
   * MOUSE MOVE
   * ============================================================
   */

  document.addEventListener(
    'mousemove',
    function (event) {

      if (
        !dragging ||
        !activeStage
      ) {

        return;

      }


      translateX =
        event.clientX -
        startX;


      translateY =
        event.clientY -
        startY;


      updateTransform();

    }
  );


  /*
   * ============================================================
   * MOUSE UP
   * ============================================================
   */

  document.addEventListener(
    'mouseup',
    function () {

      if (!activeStage) {

        return;

      }


      dragging = false;


      activeStage.classList.remove(
        'is-dragging'
      );

    }
  );


  /*
   * ============================================================
   * MOBILE TOUCH
   * ============================================================
   */

  function getTouchDistance(
    touches
  ) {

    const dx =
      touches[0].clientX -
      touches[1].clientX;


    const dy =
      touches[0].clientY -
      touches[1].clientY;


    return Math.sqrt(
      dx * dx +
      dy * dy
    );

  }


  /*
   * ============================================================
   * TOUCH START
   * ============================================================
   */

  document.addEventListener(
    'touchstart',
    function (event) {

      const stage =
        event.target.closest(
          '[data-product-zoom-stage]'
        );


      if (!stage) {

        return;

      }


      activeStage = stage;


      activeImage =
        activeStage.querySelector(
          '.product-media__image'
        );


      /*
       * Pinch
       */

      if (
        event.touches.length === 2
      ) {

        pinchStartDistance =
          getTouchDistance(
            event.touches
          );


        pinchStartScale =
          scale;

      }

    },
    {
      passive: true
    }
  );


  /*
   * ============================================================
   * TOUCH MOVE / PINCH ZOOM
   * ============================================================
   */

  document.addEventListener(
    'touchmove',
    function (event) {

      if (
        !activeStage ||
        event.touches.length !== 2 ||
        pinchStartDistance === null
      ) {

        return;

      }


      event.preventDefault();


      const currentDistance =
        getTouchDistance(
          event.touches
        );


      const ratio =
        currentDistance /
        pinchStartDistance;


      scale =
        pinchStartScale *
        ratio;


      scale = Math.max(
        1,
        Math.min(4, scale)
      );


      if (scale > 1) {

        setZoomedState();

      }


      updateTransform();

    },
    {
      passive: false
    }
  );


  /*
   * ============================================================
   * TOUCH END
   * ============================================================
   */

  document.addEventListener(
    'touchend',
    function (event) {

      if (
        event.touches.length < 2
      ) {

        pinchStartDistance = null;

      }

    }
  );


  /*
   * ============================================================
   * ESC
   * ============================================================
   */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key !== 'Escape'
      ) {

        return;

      }


      if (
        activeStage &&
        scale > 1
      ) {

        resetZoom();

      }

    }
  );


})();
  } catch(e) { console.error(e); }
})();

})();
